export default __webpack_public_path__ + "static/media/sppd-logo.01efdd3a.png";